import React from 'react';
import { Columns } from '@components/Columns';
import {
  StyledRegistryCross,
  StyledCenterBody,
  ButtonsContainer,
  FeatureText,
  CrossTextPairing,
  StyledTextColumn,
  FeatureImage,
} from './RegistryCross.styles';
import { registryPageData } from '@data-ts/pages/honeymoon-registry';
import ReactHtmlParser from 'react-html-parser';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';

const registryCrossSectionData = registryPageData.registryCrossSection;

interface RegistryCrossProps {}

export const RegistryCross: React.FC<RegistryCrossProps> = () => {
  return (
    <StyledRegistryCross as="section" id="Registry_Best_Part">
      <StyledCenterBody paddingTop={[12]} paddingBottom={[12]}>
        <StyledTextColumn centered>
          <Columns.Column width={12}>
            <Flex flexDirection={'column'} alignItems={'center'} paddingBottom={[10]}>
              <CrossTextPairing
                alignment="center"
                eyebrow={registryCrossSectionData.eyebrow}
                eyebrowColor="humanaDark4"
                eyebrowVariant="sectionEyeBrow20"
                eyebrowTagName="h2"
                title={registryCrossSectionData.title}
                titleVariant="hed56"
                titleColor="humanaDark6"
                titleTagName="h2"
                body={registryCrossSectionData.body}
                bodyVariant="dek24"
                bodyColor="neutra6"
                bodyTagName="p"
              />
              <ButtonsContainer marginTop={[10]}>
                <GetStartedButton id="honeymoonRegistryBestPartGetStartedBtn" page={'registry'} variant="secondary">
                  {registryPageData.getStarted}
                </GetStartedButton>
              </ButtonsContainer>
            </Flex>
          </Columns.Column>
        </StyledTextColumn>
        <Columns marginTop={8} marginBottom={10} centered verticalAlign="flex-start">
          {registryCrossSectionData.featuresData.map((item, index) => (
            <Columns.Column key={index} width={3}>
              <Flex alignItems="center" justifyContent="center" flexDirection="column">
                <FeatureImage>
                  <CloudImage src={item.image} width={32} height={32} />
                </FeatureImage>
                <FeatureText textAlign="center" tagName="h2" variant="featureHed17" color="humanaDark6">
                  {ReactHtmlParser(item.title)}
                </FeatureText>
              </Flex>
            </Columns.Column>
          ))}
        </Columns>
        <Columns marginBottom={10} centered>
          <Columns.Column width={12}>
            <CloudImage src="honeymoon-fund/joy-cross-v2.jpg" width={'100%'} />
          </Columns.Column>
        </Columns>
      </StyledCenterBody>
    </StyledRegistryCross>
  );
};
